import { requestSystemDownloadLoanEtc } from 'utils/http/api/system/loans';
import useModal from 'utils/modal/useModal';

export function useSystemFinancingDetailAdditionalDocumentsLogics(loanId: number) {
  const modal = useModal();
  // 대출 기타 파일 다운로드 호출
  const onClickDownloadLoanEtc = async (e: any, loanEtcAttachmentId: number) => {
    e.preventDefault();
    try {
      await requestSystemDownloadLoanEtc(loanId, loanEtcAttachmentId);
    } catch (e: any) {
      modal.show(e);
    }
  };

  return { onClickDownloadLoanEtc };
}
